import Vue from 'vue';
import Fragment from 'vue-fragment';
import * as VueGoogleMaps from 'vue2-google-maps';
import { TooltipPlugin, CollapsePlugin, TabsPlugin } from 'bootstrap-vue';  // ui plugins
import store from './store';
import App from './containers/national-list-filter-app.vue';
import * as CONST from './utils/constants';

Vue.use(Fragment.Plugin);

// init ui plugins add/remove as needed
Vue.use(TabsPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);

Vue.use(VueGoogleMaps, {
	load: {
		key: CONST.googleMapsKey,
		libraries: 'places', // This is required if you use the Autocomplete plugin
	},
});

// init app
new Vue({
	store,
	components: {
		app: App
	},
}).$mount('#national-list-app');